import { Injectable } from '@angular/core';
import {
  IPluviometro,
  ICreatePluviometro,
  IQueryParam,
  IUpdatePluviometro,
  IComando,
  IAlerta,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class PluviometrosService {
  constructor(private http: HttpService) {}

  // Pluviometros
  public getPluviometro(id: string): Observable<IPluviometro> {
    return this.http.get(`${api}/pluviometros/${id}`);
  }
  public getPluviometros(queryParams?: IQueryParam): Observable<{
    data: IPluviometro[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/pluviometros`, { params });
  }
  public createPluviometro(data: ICreatePluviometro): Observable<IPluviometro> {
    return this.http.post(`${api}/pluviometros`, data);
  }
  public updatePluviometro(
    id: string,
    data: IUpdatePluviometro,
  ): Observable<IPluviometro> {
    return this.http.put(`${api}/pluviometros/${id}`, data);
  }
  public deletePluviometro(id: string): Observable<IPluviometro> {
    return this.http.delete(`${api}/pluviometros/${id}`);
  }

  // Reportes

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(
      `${api}/reportes/exportar/pluviometro`,
      filename,
      params,
    );
  }

  // Comandos

  public solicitarUbicacion(deveui: string): Observable<IPluviometro> {
    return this.http.post(`${api}/comandos/pluviometro/ubicacion`, { deveui });
  }

  public delComando(id: string): Observable<IComando> {
    return this.http.delete(`${api}/comandos/${id}`);
  }

  // Alertas

  public delAlerta(id: string): Observable<IAlerta> {
    return this.http.delete(`${api}/alertas/${id}`);
  }

  // Parseos

  public estadoEstacion(dato: IPluviometro) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public fechaEnXDiasALas00(dias: number): Date {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + dias);
    fecha.setHours(0, 0, 0, 0);
    return fecha;
  }

  public fechaHaceXHorasALas00(horas: number): Date {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    fecha.setMinutes(0, 0, 0);
    return fecha;
  }

  public direccionViento(direccion: number = 0): string {
    if (direccion >= 0 && direccion < 22.5) {
      return 'Norte';
    }
    if (direccion >= 22.5 && direccion < 67.5) {
      return 'Noreste';
    }
    if (direccion >= 67.5 && direccion < 112.5) {
      return 'Este';
    }
    if (direccion >= 112.5 && direccion < 157.5) {
      return 'Sureste';
    }
    if (direccion >= 157.5 && direccion < 202.5) {
      return 'Sur';
    }
    if (direccion >= 202.5 && direccion < 247.5) {
      return 'Suroeste';
    }
    if (direccion >= 247.5 && direccion < 292.5) {
      return 'Oeste';
    }
    if (direccion >= 292.5 && direccion < 337.5) {
      return 'Noroeste';
    }
    if (direccion >= 337.5 && direccion < 360) {
      return 'Norte';
    }
    return 'Desconocido';
  }

  static parseoEstado(pluv: IPluviometro) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - 6);
    const ultimaComunicacion = pluv.ultimaComunicacion
      ? new Date(pluv.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || fecha > ultimaComunicacion) {
      return `<span class="material-icons" style="color: red">error</span>`;
    }

    return `<span class="material-icons" style="color: green">check_circle</span>`;
  }

  static parsearCargando(bool: boolean) {
    if (bool) {
      return `<span class="material-icons" style="color: green">check</span>`;
    } else {
      return `<span class="material-icons" style="color: red">clear</span>`;
    }
  }
}
